import {StyleSheet} from 'react-native';

import {grayscale} from '/theme/color/on.color';

export const styles = StyleSheet.create({
  container: {marginBottom: 10, padding: 16},
  title: {
    fontWeight: 'bold',
    fontSize: 20,
    marginBottom: 8,
  },
  card: {
    backgroundColor: '#F9FAFB',
    borderRadius: 8,
    padding: 24,
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'flex-start',
    flexWrap: 'wrap',
    borderWidth: 0.5,
    borderColor: grayscale,
    gap: 8,
  },
  textContainer: {
    flexShrink: 1,
    minWidth: 0,
  },
  actionButton: {
    marginTop: 4,
    alignSelf: 'flex-start',
  },

  highlight: {
    color: '#6963DF',
    fontWeight: 'bold',
  },
  normallight: {
    color: '#5B21B6',
    fontWeight: 'bold',
  },
  link: {
    color: '#6B7280',
    fontWeight: '500',
  },
  highestStreak: {
    marginTop: 8,
  },
});
